import { User } from './customer';
import { RouteData } from './route';

export enum Roles {
	Manager,
	Chef,
	Technician
}

export function isInRole(roles: Role[], user: User): boolean {
	if (user) {
		return roles.indexOf(user.role) >= 0;
	}

	return false;
}

export function hasAuthorization(route: RouteData, user: User): boolean {
	if (user != null && route != null) {
		if (route.authorizations != null) {
			const userAuths = user.scope ? user.scope.authorizations : null;

			if (userAuths != null) {
				let hasAuthorization = false;

				route.authorizations.forEach(auth => {
					const found: Authorization = userAuths.find(ua => ua.name === auth);
					hasAuthorization = found && found.read;
				});

				return hasAuthorization;
			}
		}
	}

	return true;
}

export function canWriteShop(user: User): boolean {
	const route = {
		authorizations: ['Website:Shop']
	} as RouteData;
	return canWrite(route, user);
}

export function isPartner(user: User): boolean {
	const route = {
		authorizations: ['Website:CustomerArea']
	} as RouteData;
	return !!canWrite(route, user) && !canWriteShop(user);
}

export function canAccessApp(user: User): boolean {
	if (user != null) {
		const userAuths: Authorization[] = user.scope ? user.scope.authorizations : null;

		if (userAuths != null) {
			return userAuths.filter(o => o.name.startsWith('Website') === false).some(o => o.read || o.write);
		}
	}

	return false;
}

export function canWrite(route: RouteData, user: User): boolean {
	if (user != null && route != null) {
		if (route.authorizations != null) {
			const userAuths = user.scope ? user.scope.authorizations : null;

			if (userAuths != null) {
				let hasAuthorization = false;

				route.authorizations.forEach(auth => {
					const found: Authorization = userAuths.find(ua => ua.name === auth);
					hasAuthorization = found && found.write;
				});

				return hasAuthorization;
			}
		}
	}

	return false;
}

export interface Role {
	id: string;
	name: string;
	customerId: number;
	isGlobal: boolean;
	isGGExclusive: boolean;
	authorizations: Authorization[];
	users: number;
}

export interface Authorization {
	id: string;
	name: string;
	isGGExclusive: boolean;
	read: boolean;
	write: boolean;
}
